import React,{useState, useEffect} from "react";
import { GetLocalStorage } from "../../../../Helpers/LocalStorage/LocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { FetchInstituteTrainingAndOfficeHours, UpdateInstituteTrainingAndOfficeHours } from "../../../../Actions/StudentA";
import ReuseablePopup from "../../../../Components/ReuseablePopups/ReuseablePopup";
import errorMessageImage from "../Assets/errorMessage.png";

const SchoolTimingsAndSchedule = ({}) => {
    const Border = "border-[#E2E2E2] border-[1px] border-solid";

    const Dispatch = useDispatch();

    const InstituteId = GetLocalStorage("UserInfo")?.Institute?.InstituteId;
    console.log("InstituteId in SchoolTimingsAndSchedule is:",InstituteId)

    const { InstituteTrainingAndOfficeHours } = useSelector((Store) => Store.StudentReducer);
    console.log("InstituteTrainingAndOfficeHours is:",InstituteTrainingAndOfficeHours)

    const daysOfWeek = [
        'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday',
      ];

     // Generate time options in 30-minute intervals
    // const timeOptions = [];
    // for (let hour = 0; hour < 24; hour++) {
    //     for (let minute = 0; minute < 60; minute += 30) {
    //     const time = new Date(0, 0, 0, hour, minute);
    //     const formattedTime = time.toLocaleTimeString([], {
    //         hour: '2-digit',
    //         minute: '2-digit',
    //         hour12: true,
    //     });
    //     timeOptions.push(formattedTime);
    //     }
    // }

    function formatTime(minutes) {
        const h = Math.floor(minutes / 60);
        const m = minutes % 60;
        const period = h >= 12 ? 'PM' : 'AM';
        const hour = h % 12 === 0 ? 12 : h % 12;
        // return `${hour}:${m.toString().padStart(2, '0')} ${period}`;
        return `${hour.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')} ${period}`;
      }
      
    const timeOptions = [];
    for (let minutes = 0; minutes < 24 * 60; minutes += 30) {
    timeOptions.push(formatTime(minutes));
    }
      
    const [officeHours, setOfficeHours] = useState({
        fromDay: '',
        toDay: '',
        fromTime: '',
        toTime: '',
        breakFrom: '',
        breakTo: '',
      });
      
      const [trainingHours, setTrainingHours] = useState({
        fromDay: '',
        toDay: '',
        fromTime: '',
        toTime: '',
      });
      const [breakTimeOptions, setBreakTimeOptions] = useState([]);
      const [originalOfficeHours, setOriginalOfficeHours] = useState(null);
      const [originalTrainingHours, setOriginalTrainingHours] = useState(null);
      const [isUpdatedPopup, setIsUpdatedPopup] = useState(false);
      const [isUpdationFailedPopup, setIsUpdationFailedPopup] = useState(false);
      const [errorMessageText, setErrorMessageText] = useState("Something Went Wrong");

      useEffect(() => {
        if(InstituteId){
            Dispatch(FetchInstituteTrainingAndOfficeHours(InstituteId))
        }
      }, [InstituteId]);

      function timeSortAsc(a, b) {
        const parse = (t) => {
          const [time, modifier] = t.split(' ');
          let [hours, minutes] = time.split(':').map(Number);
          if (modifier === 'PM' && hours < 12) hours += 12;
          if (modifier === 'AM' && hours === 12) hours = 0;
          return hours * 60 + minutes;
        };
        return parse(a) - parse(b);
      }

      function padTime(time) {
        const [hourMin, ampm] = time.split(' ');
        let [hour, min] = hourMin.split(':');
        if (hour.length === 1) hour = '0' + hour;
        return `${hour}:${min} ${ampm}`;
      }

      useEffect(() => {
        if (!InstituteTrainingAndOfficeHours) return;
      
        const { officeHours: office, trainingHours } = InstituteTrainingAndOfficeHours;
      
        console.log("InstituteTrainingAndOfficeHours:", InstituteTrainingAndOfficeHours);
      
        // --- Office Hours ---
        if (office) {
          const officeData = {
            fromDay: office.StartDayOfWeek || '',
            toDay: office.EndDayOfWeek || '',
            fromTime: office.StartTime || '',
            toTime: office.EndTime || '',
            breakFrom: office.StartBreakTime || '',
            breakTo: office.EndBreakTime || '',
          };
          setOfficeHours(officeData);
          setOriginalOfficeHours(officeData); // <- Save original snapshot
          console.log("Office Hours Set:", officeData);
        } else {
          const emptyOffice = {
            fromDay: '',
            toDay: '',
            fromTime: '',
            toTime: '',
            breakFrom: '',
            breakTo: '',
          };
          setOfficeHours(emptyOffice);
          setOriginalOfficeHours(emptyOffice);
          console.log("Office Hours Not Found, Defaulting to Empty");
        }
      
        // --- Training Hours ---
        if (trainingHours && trainingHours.length > 0) {
          const uniqueDays = [...new Set(trainingHours.map(t => t.DayOfWeek))];
          uniqueDays.sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));
          const fromDay = uniqueDays[0];
          const toDay = uniqueDays[uniqueDays.length - 1];
      
          const startTimes = [...new Set(trainingHours.map(t => t.StartTime))];
          startTimes.sort((a, b) => new Date(`1970/01/01 ${a}`) - new Date(`1970/01/01 ${b}`));
          const earliestTime = startTimes[0];
      
          const endTimes = [...new Set(trainingHours.map(t => t.EndTime))];
          endTimes.sort((a, b) => new Date(`1970/01/01 ${a}`) - new Date(`1970/01/01 ${b}`));
          const latestTime = endTimes[endTimes.length - 1];
      
          const trainingData = {
            fromDay,
            toDay,
            fromTime: padTime(earliestTime),
            toTime: padTime(latestTime),
          };
          setTrainingHours(trainingData);
          setOriginalTrainingHours(trainingData); // <- Save original snapshot
          console.log("Final Training Hours:", trainingData);
        } else {
          const emptyTraining = {
            fromDay: '',
            toDay: '',
            fromTime: '',
            toTime: '',
          };
          setTrainingHours(emptyTraining);
          setOriginalTrainingHours(emptyTraining);
        }
      }, [InstituteTrainingAndOfficeHours]);
      

    //   useEffect(() => {
    //     if (!InstituteTrainingAndOfficeHours) return;

    //     const { officeHours: office, trainingHours: trainingHours } = InstituteTrainingAndOfficeHours;

    //     console.log("InstituteTrainingAndOfficeHours:", InstituteTrainingAndOfficeHours);

    //     // --- Office Hours ---
    //     if (office) {
    //         setOfficeHours({
    //         fromDay: office.StartDayOfWeek || '',
    //         toDay: office.EndDayOfWeek || '',
    //         fromTime: office.StartTime || '',
    //         toTime: office.EndTime || '',
    //         breakFrom: office.StartBreakTime || '',
    //         breakTo: office.EndBreakTime || '',
    //         });
    //         console.log("Office Hours Set:", {
    //         fromDay: office.StartDayOfWeek || '',
    //         toDay: office.EndDayOfWeek || '',
    //         fromTime: office.StartTime || '',
    //         toTime: office.EndTime || '',
    //         });
    //     } else {
    //         setOfficeHours({
    //         fromDay: '',
    //         toDay: '',
    //         fromTime: '',
    //         toTime: '',
    //         breakFrom: '',
    //         breakTo: '',
    //         });
    //         console.log("Office Hours Not Found, Defaulting to Empty");
    //     }

    //     // --- Training Hours ---
    //     if (trainingHours && trainingHours.length > 0) {
    //         // Get all unique days
    //         const uniqueDays = [...new Set(trainingHours.map(t => t.DayOfWeek))];
        
    //         // Sort days by the order of the week
    //         uniqueDays.sort((a, b) => dayOrder.indexOf(a) - dayOrder.indexOf(b));
    //         const fromDay = uniqueDays[0];
    //         const toDay = uniqueDays[uniqueDays.length - 1];
        
    //         // Get unique StartTimes and sort them by actual time
    //         const startTimes = [...new Set(trainingHours.map(t => t.StartTime))];
    //         startTimes.sort((a, b) => new Date(`1970/01/01 ${a}`) - new Date(`1970/01/01 ${b}`));
    //         const earliestTime = startTimes[0];
        
    //         // Get unique EndTimes and sort them by actual time
    //         const endTimes = [...new Set(trainingHours.map(t => t.EndTime))];
    //         endTimes.sort((a, b) => new Date(`1970/01/01 ${a}`) - new Date(`1970/01/01 ${b}`));
    //         const latestTime = endTimes[endTimes.length - 1];
        
    //         console.log("Final Training Hours:", { fromDay, toDay, fromTime: earliestTime, toTime: latestTime });
        
    //         setTrainingHours({
    //             fromDay,
    //             toDay,
    //             fromTime: padTime(earliestTime),
    //             toTime: padTime(latestTime),
    //           });
    //       } else {
    //         setTrainingHours({
    //           fromDay: '',
    //           toDay: '',
    //           fromTime: '',
    //           toTime: '',
    //         });
    //       }
    // }, [InstituteTrainingAndOfficeHours]);

      const getTimeIntervals = (startTime, endTime, intervalMinutes) => {
        const times = [];
      
        const [startHour, startMinute] = convertTo24(startTime);
        const [endHour, endMinute] = convertTo24(endTime);
      
        const start = new Date();
        start.setHours(startHour, startMinute, 0, 0);
      
        const end = new Date();
        end.setHours(endHour, endMinute, 0, 0);
      
        while (start <= end) {
          let hours = start.getHours();
          const minutes = start.getMinutes();
          const ampm = hours >= 12 ? 'PM' : 'AM';
          const displayHour = hours % 12 || 12;
      
          const formatted = `${displayHour}:${minutes.toString().padStart(2, '0')} ${ampm}`;
          times.push(formatted);
      
          start.setMinutes(start.getMinutes() + intervalMinutes);
        }
      
        return times;
      };
      
      const convertTo24 = (time12h) => {
        const [time, modifier] = time12h.split(' ');
        let [hours, minutes] = time.split(':').map(Number);
      
        if (modifier === 'PM' && hours < 12) {
          hours += 12;
        }
        if (modifier === 'AM' && hours === 12) {
          hours = 0;
        }
      
        return [hours, minutes];
      };

      const convertToBreakMinutes = (timeStr) => {
        const [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':').map(Number);
      
        if (modifier === 'PM' && hours !== 12) hours += 12;
        if (modifier === 'AM' && hours === 12) hours = 0;
      
        return hours * 60 + minutes;
      };
      
      const convertToTimeStr = (minutes) => {
        let hrs = Math.floor(minutes / 60) % 24;
        let mins = minutes % 60;
        const modifier = hrs >= 12 ? 'PM' : 'AM';
      
        if (hrs === 0) hrs = 12;
        else if (hrs > 12) hrs -= 12;
      
        return `${hrs}:${mins.toString().padStart(2, '0')} ${modifier}`;
      };
      
      const getBreakTimeIntervals = (fromTime, toTime, stepMinutes) => {
        const fromMinutes = convertToBreakMinutes(fromTime);
        let toMinutes = convertToBreakMinutes(toTime);
      
        // Handle next-day scenario
        if (toMinutes <= fromMinutes) toMinutes += 24 * 60;
      
        const intervals = [];
        for (let current = fromMinutes; current <= toMinutes; current += stepMinutes) {
          intervals.push(convertToTimeStr(current));
        }
      
        return intervals;
      };
        
      useEffect(() => {
        const { fromTime, toTime } = officeHours;
      
        if (fromTime && toTime) {
          const intervals = getBreakTimeIntervals(fromTime, toTime, 30);
          setBreakTimeOptions(intervals);
        } else {
          setBreakTimeOptions([]);
        }
      }, [officeHours.fromTime, officeHours.toTime]);
      

      const dayOrder = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

        function getDayRange(start, end) {
        const startIndex = dayOrder.indexOf(start);
        const endIndex = dayOrder.indexOf(end);
        if (startIndex === -1 || endIndex === -1) return [];

        return startIndex <= endIndex
            ? dayOrder.slice(startIndex, endIndex + 1)
            : [...dayOrder.slice(startIndex), ...dayOrder.slice(0, endIndex + 1)];
        }

        function toMinutes(timeStr) {
        const [time, period] = timeStr.split(' ');
        let [hours, minutes] = time.split(':').map(Number);
        if (period === 'PM' && hours !== 12) hours += 12;
        if (period === 'AM' && hours === 12) hours = 0;
        return hours * 60 + minutes;
        }

        // function formatTime(minutes) {
        // const h = Math.floor(minutes / 60);
        // const m = minutes % 60;
        // const period = h >= 12 ? 'PM' : 'AM';
        // const hour = h % 12 === 0 ? 12 : h % 12;
        // return `${hour}:${m.toString().padStart(2, '0')} ${period}`;
        // }

        async function generateSlots({ fromDay, toDay, fromTime, toTime, breakFrom, breakTo }) {
        const days = getDayRange(fromDay, toDay);
        const startMin = toMinutes(fromTime);
        const endMin = toMinutes(toTime);
        const breakStart = toMinutes(breakFrom);
        const breakEnd = toMinutes(breakTo);

        const slots = [];

        days.forEach((day) => {
            let current = startMin;
            while (current < endMin) {
            let next = current + 60;
            if (next > endMin) next = endMin;

            if (
                (current >= breakStart && current < breakEnd) ||
                (next > breakStart && next <= breakEnd) ||
                (current < breakStart && next > breakEnd)
            ) {
                current = breakEnd; // Skip break time
                continue;
            }

            slots.push({
                day,
                start: formatTime(current),
                end: formatTime(next),
            });

            current = next;
            }
        });

        return slots;
        }

        async function generateTrainingSlots({ fromDay, toDay, fromTime, toTime }) {
            const days = getDayRange(fromDay, toDay);
            let startMin = toMinutes(fromTime);
            let endMin = toMinutes(toTime);
          
            // Handle overnight ranges by treating endMin as the next day
            const isOvernight = endMin <= startMin;
            if (isOvernight) endMin += 24 * 60; // add 24 hours to endMin
          
            const slots = [];
          
            days.forEach((day, index) => {
              let current = startMin;
              while (current < endMin) {
                let next = current + 60;
                if (next > endMin) next = endMin;
          
                const actualDayIndex = (index + Math.floor(current / (24 * 60))) % days.length;
                const actualDay = days[actualDayIndex];
          
                slots.push({
                  day: actualDay,
                  start: formatTime(current % (24 * 60)),
                  end: formatTime(next % (24 * 60)),
                });
          
                current = next;
              }
            });
          
            console.log("slots are:", slots);
            return slots;
          }          

    //    async function generateTrainingSlots({ fromDay, toDay, fromTime, toTime }) {
    //         const days = getDayRange(fromDay, toDay);
    //         const startMin = toMinutes(fromTime);
    //         const endMin = toMinutes(toTime);
          
    //         const slots = [];
          
    //         days.forEach((day) => {
    //           let current = startMin;
    //           while (current < endMin) {
    //             let next = current + 60;
    //             if (next > endMin) next = endMin;
          
    //             slots.push({
    //               day,
    //               start: formatTime(current),
    //               end: formatTime(next),
    //             });
          
    //             current = next;
    //           }
    //         });
    //         console.log("slots are:",slots)

    //         return slots;
    //       }

        const handleUpdate = async () => {
            // const officeSlots = await generateSlots(officeHours);
            console.log("trainingHours are in handleUpdate:",trainingHours)

            const trainingSlots = await generateTrainingSlots(trainingHours);

            // console.log("officeSlots are:",officeSlots)
            console.log("trainingSlots are:",trainingSlots)

            Dispatch(UpdateInstituteTrainingAndOfficeHours(officeHours, trainingSlots, InstituteId, () => {
                console.log(" UpdateInstituteTrainingAndOfficeHours Successfully!");
                setIsUpdatedPopup(true)
                 // Reload the page after the update is successful
                // window.location.reload();
            },
            (errorMessage) => {
                setErrorMessageText(errorMessage)
                setIsUpdationFailedPopup(true)
            }
        ))
        }

        const hasChanges = () => {
            if (!originalOfficeHours || !originalTrainingHours) return false;
          
            const officeChanged = JSON.stringify(officeHours) !== JSON.stringify(originalOfficeHours);
            const trainingChanged = JSON.stringify(trainingHours) !== JSON.stringify(originalTrainingHours);
          
            return officeChanged || trainingChanged;
          };

          const isAllFieldsFilled = () => {
            const officeFieldsFilled = Object.values(officeHours).every(val => val.trim() !== '');
            const trainingFieldsFilled = Object.values(trainingHours).every(val => val.trim() !== '');
            return officeFieldsFilled && trainingFieldsFilled;
          };

        const convertToMinutes = (timeStr) => {
        const [time, modifier] = timeStr.split(' ');
        let [hours, minutes] = time.split(':').map(Number);
        
        if (modifier === 'PM' && hours !== 12) hours += 12;
        if (modifier === 'AM' && hours === 12) hours = 0;
        
        return hours * 60 + minutes;
        };     
          
    return (
        <div className="w-full bg-[#F8FAFA] rounded-[10px] flex flex-col gap-[10px] p-[20px]"
        //  style={{
        //         borderLeft: "1px solid #CECECE"
        //     }}
            >
            <p className="text-[20px] text-[#2D2366] font-bold">Office Hours of institute.</p>
            <p className="text-[22px] text-[#2D2366] ">These hours will be visible to the enrolled student in about institute page.</p>

            <div className="w-full flex justify-between mt-[10px]">
                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">From (Day)</label>
                    <select  
                    value={officeHours.fromDay || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setOfficeHours((prev) => ({ ...prev, fromDay: e.target.value }))
                    }>
                        <option value="" disabled selected>
                            Select a day...
                        </option>
                        {daysOfWeek.map((day) => (
                        <option key={day} 
                        value={day}
                        disabled={day === officeHours.toDay} // For From Day
                        >
                            {day}
                        </option>
                        ))}
                    </select>
                </div>

                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">To (Day)</label>
                    <select 
                    value={officeHours.toDay || ""} 
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setOfficeHours((prev) => ({ ...prev, toDay: e.target.value }))
                    }
                    >
                        <option value="" disabled selected>
                            Select a day...
                        </option>
                        {daysOfWeek.map((day) => (
                        <option key={day} 
                        value={day}
                        disabled={day === officeHours.fromDay} // For To Day
                        >
                            {day}
                        </option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="w-full flex justify-between mt-[10px]">
                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">From (Time)</label>
                    <select 
                    value={officeHours.fromTime || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setOfficeHours((prev) => ({ ...prev, fromTime: e.target.value }))
                    }>
                        <option value="" disabled selected>
                            Select time...
                        </option>
                        {timeOptions.map((time, index) => (
                            <option key={index} value={time}>
                            {time}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">To (Time)</label>
                    <select 
                    value={officeHours.toTime || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setOfficeHours((prev) => ({ ...prev, toTime: e.target.value }))
                    }>
                        <option value="" disabled selected>
                            Select time...
                        </option>
                        {/* {timeOptions
                        .filter((time) => {
                            if (!officeHours.fromTime) return true;
                            const from = convertToMinutes(officeHours.fromTime);
                            const to = convertToMinutes(time);

                            // If to time is PM and earlier than from PM, disallow
                            // Same for AM and crossing midnight is allowed
                            return to > from || to < from; // allow crossing to next day
                        })
                        .filter((time) => {
                            if (!officeHours.fromTime) return true;

                            const from = convertToMinutes(officeHours.fromTime);
                            const to = convertToMinutes(time);

                            const isFromAM = officeHours.fromTime.includes('AM');
                            const isToAM = time.includes('AM');

                            // Both AM or both PM: block earlier/equal times
                            if (isFromAM === isToAM) return to > from;

                            // Different meridian (e.g., 4PM to 2AM) — allow
                            return true;
                        })
                        .map((time, index) => (
                            <option key={index} value={time}>
                            {time}
                            </option>
                        ))} */}

                        {officeHours.fromTime &&
                        timeOptions
                            .filter((time) => {
                            const from = convertToMinutes(officeHours.fromTime);
                            const to = convertToMinutes(time);

                            return to > from || to < from; // allow crossing to next day
                            })
                            .filter((time) => {
                            const from = convertToMinutes(officeHours.fromTime);
                            const to = convertToMinutes(time);

                            const isFromAM = officeHours.fromTime.includes('AM');
                            const isToAM = time.includes('AM');

                            if (isFromAM === isToAM) return to > from;
                            return true;
                            })
                            .map((time, index) => (
                            <option key={index} value={time}>
                                {time}
                            </option>
                            ))
                        }


                        {/* {timeOptions.map((time, index) => (
                            <option key={index} value={time}>
                            {time}
                            </option>
                        ))} */}
                    </select>
                </div>
            </div>

            <div className="w-full flex justify-between mt-[10px]">
                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold"> From (Break Hours)</label>
                    <select 
                    value={officeHours.breakFrom || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setOfficeHours((prev) => ({ ...prev, breakFrom: e.target.value }))
                    }>
                        <option value="" disabled selected>
                            Select time...
                        </option>
                        {breakTimeOptions?.map((time, index) => (
                            <option key={index} value={time}>
                            {time}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">To (Break Hours)</label>
                    <select 
                    value={officeHours.breakTo || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setOfficeHours((prev) => ({ ...prev, breakTo: e.target.value }))
                    }>
                        <option value="" disabled selected>
                            Select time...
                        </option>
                        {breakTimeOptions.map((time, index) => (
                            <option key={index} value={time}>
                            {time}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* <div className="w-full mt-[10px]">
                <label className="text-[20px] text-[#404040] font-bold">Break Hours</label>
                <input
                    placeholder="12:00PM - 12:30 PM"
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setOfficeHours((prev) => ({ ...prev, breakFrom: e.target.value }))
                    }
                />
            </div> */}

            <p className="text-[20px] text-[#2D2366] font-bold mt-[20px]">Training Hours of institute.</p>
            <p className="text-[22px] text-[#2D2366] ">This schedule will help out students to provide their free hours according to the institute class timings.</p>

            <div className="w-full flex justify-between mt-[10px]">
                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">From (Day)</label>
                    <select  
                    value={trainingHours.fromDay || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                     onChange={(e) =>
                        setTrainingHours((prev) => ({ ...prev, fromDay: e.target.value }))
                    }>
                        <option value="" disabled selected>
                            Select a day...
                        </option>
                        {daysOfWeek.map((day) => (
                        <option key={day} 
                        value={day}
                        disabled={day === trainingHours.toDay} // For To Day
                        >
                            {day}
                        </option>
                        ))}
                    </select>
                </div>

                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">To (Day)</label>
                    <select  
                    value={trainingHours.toDay || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                     onChange={(e) =>
                        setTrainingHours((prev) => ({ ...prev, toDay: e.target.value }))
                    }>
                        <option value="" disabled selected>
                            Select a day...
                        </option>
                        {daysOfWeek.map((day) => (
                        <option key={day} 
                        value={day}
                        disabled={day === trainingHours.fromDay} // For To Day
                        >
                            {day}
                        </option>
                        ))}
                    </select>
                </div>
            </div>

            <div className="w-full flex justify-between mt-[10px]">
                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">From (Time)</label>
                    <select 
                    value={trainingHours.fromTime || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setTrainingHours((prev) => ({ ...prev, fromTime: e.target.value }))
                    }>
                        <option value="" disabled >
                            Select time...
                        </option>
                        {timeOptions.map((time, index) => (
                            <option key={index} value={time}>
                            {time}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">To (Time)</label>
                    <select 
                    value={trainingHours.toTime || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setTrainingHours((prev) => ({ ...prev, toTime: e.target.value }))
                    }>
                        <option value="" disabled >
                            Select time...
                        </option>
                        {timeOptions.map((time, index) => (
                            <option key={index} value={time}>
                            {time}
                            </option>
                        ))}
                    </select>
                </div>
            </div>

            {/* <div className="w-full flex justify-between mt-[10px]">
                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">From (Time)</label>
                    <select 
                    value={trainingHours.fromTime || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                     onChange={(e) =>
                        setTrainingHours((prev) => ({ ...prev, fromTime: e.target.value }))
                    }>
                        <option value="" disabled selected>
                            Select time...
                        </option>
                        {timeOptions.map((time, index) => (
                            <option key={index} value={time}>
                            {time}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="w-[49%]">
                    <label className="text-[20px] text-[#404040] font-bold">To (Time)</label>
                    <select 
                    value={trainingHours.toTime || ""}
                    className={`w-full rounded-md py-2  px-[10px] ${Border} shadow-[4px_5px_6px_#00000029] mt-[10px]`}
                    onChange={(e) =>
                        setTrainingHours((prev) => ({ ...prev, toTime: e.target.value }))
                    }>
                        <option value="" disabled selected>
                            Select time...
                        </option>
                        {timeOptions.map((time, index) => (
                            <option key={index} value={time}>
                            {time}
                            </option>
                        ))}
                    </select>
                </div>
            </div> */}

            <div className="w-full mt-[25px] flex items-center justify-between">

            <p className="text-[17px] text-[#2D2366]">
                <span className="font-bold">Note: </span>Updating the class schedule will not affect the enrolled students.
            </p>

                {InstituteTrainingAndOfficeHours.officeHours === null && InstituteTrainingAndOfficeHours.trainingHours.length === 0 ? (
                    // CREATE Button
                    <button
                    className={`w-[110px] h-[44px] rounded-[8px] text-[20px] text-white ${
                        isAllFieldsFilled() ? 'bg-[#A1A3EF] cursor-pointer' : 'bg-[#A1A3EF] opacity-50 cursor-not-allowed'
                    }`}
                    onClick={handleUpdate}
                    disabled={!isAllFieldsFilled()}
                    >
                    Create
                    </button>
                ) : (
                    // UPDATE Button
                    <button
                    className={`w-[110px] h-[44px] rounded-[8px] text-[20px] text-white ${
                        hasChanges() ? 'bg-[#A1A3EF] cursor-pointer' : 'bg-[#A1A3EF] opacity-50 cursor-not-allowed'
                    }`}
                    onClick={handleUpdate}
                    disabled={!hasChanges()}
                    >
                    Update
                    </button>
                )}
            </div>
            
            {isUpdatedPopup && (
                <ReuseablePopup
                setShowPopup={setIsUpdatedPopup}
                heading="Congratulations !!"
                text="Changes saved successfully."
                btnText="Done"
                onClick={() => setIsUpdatedPopup(false)} // <-- Add this line
                imageSrc={require("../Assets/SuccessAssets.svg").default} // ✅ Dynamic image source
                />
            )}

            {isUpdationFailedPopup && (
                <ReuseablePopup
                setShowPopup={setIsUpdationFailedPopup}
                heading="Oops!"
                text={errorMessageText}
                btnText="Back"
                onClick={() => setIsUpdationFailedPopup(false)} // <-- Add this line
                imageSrc={errorMessageImage} // ✅ Dynamic image source
                />
            )}

            {/* <div className="w-full mt-[25px] flex items-center justify-between">
                <p className="text-[17px] text-[#2D2366]"><span className="font-bold">Note: </span>Updating the class schedule will not effect the enrolled students.</p>
                <button
                    // className={`w-[110px] h-[44px] rounded-[8px] bg-[#A1A3EF] text-[#FFFFFF] text-[20px]`}
                    className={`w-[110px] h-[44px] rounded-[8px] text-[20px] text-white ${
                        hasChanges() ? 'bg-[#A1A3EF] cursor-pointer' : 'bg-[#A1A3EF] opacity-50 cursor-not-allowed'
                    }`}
                   onClick={handleUpdate}
                   disabled={!hasChanges()}
                   >
                        Update
                </button>
            </div> */}

        </div>
    );
};

export default SchoolTimingsAndSchedule;
